<template>
    <div class="hubspot-chat-button-fixed">
        <div v-if="areStatisticsCookiesEnabled">
            <div :class="{ 'hubspot-chat-button-fixed__hubspot-chat-wrapper': true, 'hubspot-chat-button-fixed__hubspot-chat-wrapper--visible': hubspotChatIsOpen }">
                <HubSpotChat @hide-chat-requested="hubspotChatIsOpen=false" wrapper_id="hubspot-chat-only"/>
            </div>
            <button v-if="!hubspotChatIsOpen" @click="toggleChat" class="hubspot-chat-button-fixed__button">
                <span
                    class="hubspot-chat-button-fixed__unread-conversations-count"
                    v-if="unreadConversationsCount > 0">{{ unreadConversationsCount }}</span>
                <img src="@/assets/images/chatbot/hubspot/button.svg" alt="">
            </button>
        </div>
        <div v-else>
            <HubspotDisabledPopup />
        </div>
    </div>
</template>

<script>
    import HubSpotChat from 'components/chatbot/customer_support/HubSpotChat.vue'
    import HubspotDisabledPopup from 'components/cookieconsent/HubspotDisabledPopup.vue'
    import hubSpotChatHelper from 'components/shared/mixins/hubSpotChatHelper'
    import { mapGetters } from 'vuex'

    export default {
        name: 'HubSpotChatOnly',
        components: { HubSpotChat, HubspotDisabledPopup },
        mixins: [hubSpotChatHelper],
    }
</script>

<style scoped lang="scss">
.hubspot-chat-button-fixed {
    font-family: Nunito-Regular, sans-serif;
    position: fixed;
    right: 20px;
    bottom: 60px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-content: flex-end;
    z-index: 9991;
    gap: 1rem;

    &__button {
        appearance: none;
        background: none;
        border: none;
        cursor: pointer;
        padding: 0;
        margin: 0;
        align-self: flex-end;
        font-family: Nunito-Regular, sans-serif;
        position: fixed;
        right: 20px;
        bottom: 20px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-content: flex-end;
        z-index: 9990;
        gap: 1rem;

        &--disabled {
            opacity: 0.7;
        }

        img {
            box-shadow: 0 0 6px 0 #00000040;
            border-radius: 50%;
        }

    }

    &__unread-conversations-count {
        position: absolute;
        top: 0;
        right: 0;
        box-shadow: 0 0 6px 0 #00000040;
        width: 20px;
        height: 20px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        font-size: 12px;
        color: $white;
        background: $metallic_red;
        border-radius: 50%;
    }


    &__hubspot-chat-wrapper {
        transition: opacity 0.2s ease-in-out;

        &--visible {
            opacity: 1;
            visibility: visible;
            pointer-events: auto;
            display: block;
        }

        &:not(&--visible) {
            opacity: 0;
            visibility: hidden;
            pointer-events: none;
            display: none;
        }
    }


    &__message {
        background: $alabaster;
        width: 288px;
        padding: 20px;
        border-radius: 10px 10px 0 10px;
        border: 1px solid $rust_orange;
        box-shadow: 0 0 6px 0 #00000040;

        &__icon-info-solid {
            color: $rust_orange;
        }

        a {
            color: $rust_orange;
            font-weight: bold;
            text-decoration: underline;
        }

        &__header {
            display: flex;
            justify-content: flex-start;
            gap: 1rem;
            margin-bottom: 1rem;

            &__close-button {
                margin-left: auto;
                box-shadow: none;
                appearance: none;
            }
        }
    }
}
</style>
